import { render } from "./SerieList.vue?vue&type=template&id=00f13f3a&scoped=true"
import script from "./SerieList.vue?vue&type=script&lang=js"
export * from "./SerieList.vue?vue&type=script&lang=js"

import "./SerieList.vue?vue&type=style&index=0&id=00f13f3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f13f3a"]])

export default __exports__